// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { router }         from './app/router'
import { ToastContainer } from './components/feedback/Toast'
import { ErrorBoundary }  from './components/feedback/ErrorBoundary'
import { AccessGate }     from './app/AccessGate'
import { AppBootstrap }   from './app/AppBootstrap'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime:           2 * 60 * 1000,
      gcTime:              10 * 60 * 1000,
      retry:               1,
      refetchOnWindowFocus: false,
    },
  },
})

export function App() {
  return (
    <ErrorBoundary>
      <AccessGate>
        <AppBootstrap>
          <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} future={{ v7_startTransition: true }} />
            <ToastContainer />
          </QueryClientProvider>
        </AppBootstrap>
      </AccessGate>
    </ErrorBoundary>
  )
}
